/**
 * explain/mdComponents.jsx — Iter84 extraction.
 *
 * react-markdown component overrides for the ExplainDeeperSheet's
 * whitepaper rendering. Pure config; lives here so the orchestrator
 * file doesn't carry ~30 lines of presentational mapping.
 */
const mdComponents = {
  h2: (p) => <h2 className="font-display text-2xl md:text-3xl tracking-tight mt-6 mb-3 text-white" {...p} />,
  h3: (p) => <h3 className="font-display text-lg md:text-xl tracking-tight mt-6 mb-2 text-white/95" {...p} />,
  h4: (p) => <h4 className="font-display text-base tracking-tight mt-4 mb-1.5 text-white/90" {...p} />,
  p:  (p) => <p className="text-[15px] leading-relaxed text-white/80 my-3" {...p} />,
  ul: (p) => <ul className="list-disc pl-5 space-y-1.5 my-3 text-white/80 text-[15px] marker:text-[#00FF9D]" {...p} />,
  ol: (p) => <ol className="list-decimal pl-5 space-y-1.5 my-3 text-white/80 text-[15px] marker:text-[#0044FF]" {...p} />,
  li: (p) => <li className="leading-relaxed" {...p} />,
  strong: (p) => <strong className="text-white font-semibold" {...p} />,
  em: (p) => <em className="text-white/90" {...p} />,
  code: ({ inline, ...p }) =>
    inline ? (
      <code className="font-mono-oak text-[13px] px-1.5 py-0.5 rounded bg-white/10 text-[#8aa8ff]" {...p} />
    ) : (
      <code className="block font-mono-oak text-[13px] p-3 rounded-lg bg-black/40 border border-white/10 overflow-x-auto" {...p} />
    ),
  pre: (p) => <pre className="my-3" {...p} />,
  blockquote: (p) => (
    <blockquote
      className="my-5 pl-4 pr-4 py-3 rounded-r-lg border-l-2 border-[#00FF9D]/60 bg-[#00FF9D]/[0.04] text-white/90 text-[14.5px] leading-relaxed"
      {...p}
    />
  ),
  table: (p) => <div className="overflow-x-auto my-4"><table className="w-full text-[13.5px] border-collapse" {...p} /></div>,
  thead: (p) => <thead className="bg-white/5" {...p} />,
  th: (p) => <th className="px-3 py-2 text-left font-semibold border border-white/10" {...p} />,
  td: (p) => <td className="px-3 py-2 border border-white/10 text-white/80 align-top" {...p} />,
  a:  (p) => <a className="text-[#8aa8ff] underline decoration-white/20 hover:decoration-white" {...p} />,
  hr: () => <hr className="my-6 border-white/10" />,
};

export default mdComponents;
